(function () {
  'use strict';

  if (window.premiumAjaxCartLoaded) {
    return;
  }

  window.premiumAjaxCartLoaded = true;

  function isAddToCartForm(form) {
    if (!(form instanceof HTMLFormElement)) {
      return false;
    }

    var action = form.getAttribute('action') || '';
    var variantInput = form.querySelector('input[name="id"]');

    return Boolean(
      variantInput &&
      (
        action.indexOf('/cart/add') !== -1 ||
        form.classList.contains('premium-product-page__form') ||
        form.classList.contains('premium-product-grid__form')
      )
    );
  }

  function getCartAddUrl() {
    if (window.routes && window.routes.cart_add_url) {
      return window.routes.cart_add_url;
    }

    if (
      window.Shopify &&
      window.Shopify.routes &&
      window.Shopify.routes.root
    ) {
      return window.Shopify.routes.root + 'cart/add.js';
    }

    return '/cart/add.js';
  }

  function setButtonLoading(button, loading) {
    if (!button) {
      return;
    }

    var textElement = button.querySelector(
      '[data-add-button-text], span'
    );

    if (loading) {
      button.dataset.originalText = textElement
        ? textElement.textContent
        : button.textContent;

      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      button.classList.add('is-loading');

      if (textElement) {
        textElement.textContent = 'Wird hinzugefügt …';
      } else {
        button.textContent = 'Wird hinzugefügt …';
      }
    } else {
      var originalText =
        button.dataset.originalText || 'In den Warenkorb';

      button.disabled = false;
      button.removeAttribute('aria-busy');
      button.classList.remove('is-loading');

      if (textElement) {
        textElement.textContent = originalText;
      } else {
        button.textContent = originalText;
      }
    }
  }

  function showSuccess(button) {
    if (!button) {
      return;
    }

    var textElement = button.querySelector(
      '[data-add-button-text], span'
    );

    if (textElement) {
      textElement.textContent = 'Hinzugefügt ✓';
    } else {
      button.textContent = 'Hinzugefügt ✓';
    }
  }

  function showFormError(form, message) {
    var errorElement = form.querySelector(
      '[data-product-error], .product-form__error-message'
    );

    if (errorElement) {
      errorElement.textContent = message;
      errorElement.hidden = false;
      return;
    }

    console.error(message);
    window.alert(message);
  }

  async function waitForCartDrawer() {
    if (
      window.customElements &&
      window.customElements.get('cart-drawer')
    ) {
      return;
    }

    if (
      window.customElements &&
      typeof window.customElements.whenDefined === 'function'
    ) {
      await window.customElements.whenDefined('cart-drawer');
    }
  }

  document.addEventListener(
    'submit',
    async function (event) {
      var form = event.target;

      if (!isAddToCartForm(form)) {
        return;
      }

      var submitButton =
        event.submitter ||
        form.querySelector(
          '[data-add-button], button[name="add"], button[type="submit"]'
        );

      /*
       * Shopify-Payment-Buttons nicht abfangen.
       * Nur normale "In den Warenkorb"-Buttons.
       */
      if (
        submitButton &&
        submitButton.name &&
        submitButton.name !== 'add' &&
        !submitButton.hasAttribute('data-add-button')
      ) {
        return;
      }

      /*
       * Wichtig:
       * Das normale Abschicken des Formulars wird gestoppt,
       * bevor Shopify auf /cart weiterleiten kann.
       */
      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();

      var cartDrawer = document.querySelector('cart-drawer');

      if (!cartDrawer) {
        showFormError(
          form,
          'Der seitliche Warenkorb ist im Theme aktuell nicht geladen. Bitte den Warenkorbtyp auf „Drawer“ stellen.'
        );
        return;
      }

      setButtonLoading(submitButton, true);

      var errorElement = form.querySelector('[data-product-error]');

      if (errorElement) {
        errorElement.textContent = '';
        errorElement.hidden = true;
      }

      try {
        await waitForCartDrawer();

        cartDrawer = document.querySelector('cart-drawer');

        if (
          !cartDrawer ||
          typeof cartDrawer.renderContents !== 'function'
        ) {
          throw new Error(
            'Der Cart Drawer konnte nicht initialisiert werden.'
          );
        }

        var formData = new FormData(form);

        var sections = [
          'cart-drawer',
          'cart-icon-bubble'
        ];

        if (
          typeof cartDrawer.getSectionsToRender === 'function'
        ) {
          sections = cartDrawer
            .getSectionsToRender()
            .map(function (section) {
              return section.id;
            });
        }

        formData.delete('sections');
        formData.delete('sections_url');

        formData.append('sections', sections.join(','));
        formData.append(
          'sections_url',
          window.location.pathname
        );

        if (
          typeof cartDrawer.setActiveElement === 'function' &&
          submitButton
        ) {
          cartDrawer.setActiveElement(submitButton);
        }

        var response = await fetch(getCartAddUrl(), {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          credentials: 'same-origin',
          body: formData
        });

        var result = await response.json();

        if (
          !response.ok ||
          result.status ||
          result.errors
        ) {
          throw new Error(
            result.description ||
            result.message ||
            result.errors ||
            'Das Produkt konnte nicht hinzugefügt werden.'
          );
        }

        if (!result.sections) {
          throw new Error(
            'Shopify hat keine aktualisierten Warenkorb-Inhalte zurückgegeben.'
          );
        }

        cartDrawer.classList.remove('is-empty');

        var drawerInner =
          cartDrawer.querySelector('.drawer__inner');

        var drawerItems =
          cartDrawer.querySelector('cart-drawer-items');

        if (drawerInner) {
          drawerInner.classList.remove('is-empty');
        }

        if (drawerItems) {
          drawerItems.classList.remove('is-empty');
        }

        /*
         * renderContents aktualisiert:
         * - Drawer-Inhalt
         * - Warenkorb-Zähler
         * - Gesamtsumme
         * und öffnet bei Dawn/Refresh den Drawer.
         */
        cartDrawer.renderContents(result);

        /*
         * Zusätzliche Sicherheit:
         * Falls das Theme renderContents aktualisiert,
         * den Drawer aber nicht automatisch öffnet.
         */
        window.setTimeout(function () {
          if (
            !cartDrawer.classList.contains('active') &&
            typeof cartDrawer.open === 'function'
          ) {
            cartDrawer.open(submitButton);
          }
        }, 180);

        showSuccess(submitButton);

        window.setTimeout(function () {
          setButtonLoading(submitButton, false);
        }, 1200);
      } catch (error) {
        console.error(
          'Premium Ajax Cart Fehler:',
          error
        );

        showFormError(
          form,
          error.message ||
          'Das Produkt konnte leider nicht hinzugefügt werden.'
        );

        setButtonLoading(submitButton, false);
      }
    },
    true
  );
})();